import type { FeedbackTone } from "./component-model";

export const contentStateKinds = [
  "loading",
  "empty",
  "success",
  "warning",
  "error",
] as const;

export type ContentStateKind = (typeof contentStateKinds)[number];

export interface ContentStatePresentation {
  readonly tone: FeedbackTone;
  readonly label: string;
  readonly indicator: string;
  readonly busy: boolean;
}

const contentStatePresentations = {
  loading: Object.freeze({
    tone: "info",
    label: "Loading",
    indicator: "…",
    busy: true,
  }),
  empty: Object.freeze({
    tone: "neutral",
    label: "Nothing here yet",
    indicator: "·",
    busy: false,
  }),
  success: Object.freeze({
    tone: "positive",
    label: "Complete",
    indicator: "✓",
    busy: false,
  }),
  warning: Object.freeze({
    tone: "warning",
    label: "Needs attention",
    indicator: "!",
    busy: false,
  }),
  error: Object.freeze({
    tone: "critical",
    label: "Could not complete",
    indicator: "×",
    busy: false,
  }),
} as const satisfies Record<ContentStateKind, ContentStatePresentation>;

export function getContentStatePresentation(
  kind: ContentStateKind,
): ContentStatePresentation {
  return contentStatePresentations[kind];
}
